//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/NXObject.js";
import "../no/Routing.js";
import "../Preferences/Preferences.RoutingApplicationView.js";
let d=[[],[[["num_required"],"GetStockRequiredCharacteristics",{R_:{required:""}},0,0],[["num_required"],"GetComponentRequiredCharacteristics",{R_:{required:""}},0,0],[["num_optional"],"GetStockOptionalCharacteristics",{R_:{optional:""}},0,0],[["num_optional"],"GetComponentOptionalCharacteristics",{R_:{optional:""}},0,0],[["num_destination"],"GetDestintationCharacteristics",{R_:{destination:""}},0,0],[[],"GetStockCharacteristicValues",{R_:{values:"Routing.CharacteristicList"}},0,0],[["values"],"UpdateStockCharacteristicValues",{},1,0],[[],"GetComponentCharacteristicValues",{R_:{values:"Routing.CharacteristicList"}},0,0],[["values"],"UpdateComponentCharacteristicValues",{},1,0],[[],"GetDefaultElbowCharacteristicValues",{R_:{values:"Routing.CharacteristicList"}},0,0],[["values"],"UpdateDefaultElbowCharacteristicValues",{},1,0]],[]];
SPLM.Preferences.RoutingCharacteristics = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RoutingCharacteristics";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;